"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Account = void 0;
var accounts_1 = require("@near-js/accounts");
Object.defineProperty(exports, "Account", { enumerable: true, get: function () { return accounts_1.Account; } });
